import { GET_PJSIP_TRANSPORT } from './mutation-types'

export default {
  [GET_PJSIP_TRANSPORT]: (state, pjsiptransport) => {
    state.pjsiptransport = pjsiptransport
  },
}
